export const CatalogErrorGroups: Record<string, { type: string; title: string }> = {
	content: { type: "content", title: "incorrects-content" },
	links: { type: "links", title: "incorrects-paths" },
	unsupported: { type: "unsupported", title: "incorrects-unsupported" },
	images: { type: "images", title: "incorrects-paths" },
	diagrams: { type: "diagrams", title: "incorrects-paths" },
	icon: { type: "icons", title: "incorrects-icons" },
	comments: { type: "comments", title: "incorrects-comments" },
	aliases: { type: "aliases", title: "incorrects-aliases" },
};
